import { Stack, Typography } from "@mui/material";
import "./styles.scss";
import { WorkExperienceForm } from "../work-experience-form";
import { EducationForm } from "../education-form";
import { ReferenceForm } from "../reference-form";
import { BusinessGoalsAndMetricsForm } from "../business-goals-form";
import { MembershipSelection } from "../membership-selection";
import { PropsWithChildren } from "react";
import { useDesignerApplicationContext } from "../../../hooks/designer-application-context";

const StaticApplicationBlock = ({
  title,
  children,
}: PropsWithChildren<{ title: string }>) => {
  return (
    <div className="review-form-section">
      <Typography variant="h6" className="review-form-title" mb="16px">
        {title}
      </Typography>
      {children}
    </div>
  );
};

export const ReviewApplication = ({
  isEditable,
  contactReference,
  setContactReference,
}: {
  isEditable: boolean;
  setContactReference: (value: boolean) => void;
  contactReference: boolean;
}) => {
  const ctx = useDesignerApplicationContext();
  const application = (ctx as any).application ?? {};

  return (
    <div className="site-wrapper">
      <div className="review-application">
        <Typography variant="h5" className="margin-top-0 font-size-5">
          Review Application
        </Typography>

        <Stack direction="column" spacing={3} className="review-form-container">
          <StaticApplicationBlock title="Work Experience">
            <WorkExperienceForm hideNewForm isEditable={isEditable} />
          </StaticApplicationBlock>

          <StaticApplicationBlock title="Education">
            <EducationForm isEditable={isEditable} />
          </StaticApplicationBlock>

          <StaticApplicationBlock title="References">
            <ReferenceForm
              isEditable={isEditable}
              contactReference={contactReference}
              setContactReference={setContactReference}
              hideNewForm
            />
          </StaticApplicationBlock>

          <StaticApplicationBlock title="Business Information">
            <BusinessGoalsAndMetricsForm isEditable={isEditable} />
          </StaticApplicationBlock>

          <StaticApplicationBlock title="Membership and Services">
            <MembershipSelection readOnly />
          </StaticApplicationBlock>
        </Stack>
      </div>
    </div>
  );
};
